import ReceiptController from "./controller/ReceiptController";
import React, {useState} from "react";
import {ReceiptState} from "./interfaces/ReceiptState";
import MarketRepository from "../../../../Main/repository/MarketRepository";
import {useTranslation} from "react-i18next";

export default function Receipt() {
    const {t} = useTranslation();
    const setting = MarketRepository.getSettingMarket();
    const [state, setState] = useState<ReceiptState>({
        value: setting.basicReceiptInvoice
    })

    return (
        <section onSubmit={e => new ReceiptController(state, setState).saveFirstReceipt(e)}>
            <p>{t("setting.receipt")}</p>
            <div className={'form-receipt'}>
                <form>
                    <input type="number"
                           defaultValue={state.value}
                           onChange={e => new ReceiptController(state, setState).receiptInput(e)}/>
                    <button type="submit">{t("submit")}</button>
                </form>
                {state.error ? <small>{state.message}</small> : null}
            </div>
        </section>
    )
}